import React from 'react';
import { useTranslation } from 'react-i18next';
import { UnavailableCode } from '../../types';
import styles from './AgentStateDropdown.module.css';

const DEFAULT_UNAVAILABLE_CODES: UnavailableCode[] = [
  { outStateId: 'default', outStateName: 'Unavailable', isACW: false },
];

interface AgentStateDropdownProps {
  unavailableCodes: UnavailableCode[];
  onStateSelect: (state: string, reasonCode?: string) => void;
}

export function AgentStateDropdown({ unavailableCodes, onStateSelect }: AgentStateDropdownProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.dropdown}>
      <button
        className={`${styles.option} ${styles.optionAvailable}`}
        onClick={() => onStateSelect('Available')}
      >
        <span className={styles.optionIndicator} />
        {t('settings:agentState.available')}
      </button>

      <div className={styles.divider} />

      <div className={styles.sectionLabel}>{t('settings:agentState.unavailable')}</div>
      {(unavailableCodes.length > 0 ? unavailableCodes : DEFAULT_UNAVAILABLE_CODES).map((code) => (
        <button
          key={code.outStateId}
          className={`${styles.option} ${styles.optionUnavailable}`}
          onClick={() =>
            onStateSelect(
              'Unavailable',
              code.outStateId !== 'default' ? code.outStateId : undefined
            )
          }
        >
          <span className={styles.optionIndicator} />
          {code.outStateName}
        </button>
      ))}
    </div>
  );
}

export default AgentStateDropdown;
